import type { BoxProps, FlexProps } from '@chakra-ui/react'
import { Box, Flex } from '@chakra-ui/react'
import React, { useState } from 'react'

interface FlexHoverProps extends FlexProps {
  children(isHover: boolean): React.ReactElement
}

interface BoxHoverProps extends BoxProps {
  children(isHover: boolean): React.ReactElement
}

const Hover = ({
  children,
  ...props
}: BoxHoverProps | FlexHoverProps): React.ReactElement => {
  const [isHover, setIsHover] = useState<boolean>(false)

  if (props.display === 'flex') {
    return (
      <Flex
        {...props}
        onMouseOver={() => {
          setIsHover(true)
        }}
        onMouseLeave={() => {
          setIsHover(false)
        }}
      >
        {children(isHover)}
      </Flex>
    )
  }

  return (
    <Box
      {...props}
      onMouseOver={() => {
        setIsHover(true)
      }}
      onMouseLeave={() => {
        setIsHover(false)
      }}
    >
      {children(isHover)}
    </Box>
  )
}

export default Hover
